'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const DiagramModel = require('system/domain/entity/diagram');
const DirectoryModel = require('system/domain/entity/diagram-directory');
const SyncState = require('system/domain/entity/sync-state');
const DiagramCollection = require('system/domain/collection/diagram');

const DiagramStore = Backbone.Model.extend({
    initialize: function() {
        _.bindAll(this, 'dispatch');
        this._contextDiagrams = {};
        this._contextDirectories = {};
        Dispatcher.register(this.dispatch);
    },

    _diagrams: function(context) {
        let key = context.projectId + ':' + (context.dt ? context.dt : '');
        let diagrams = this._contextDiagrams[key];
        if(diagrams) {
            return diagrams;
        }
        this._contextDiagrams[key] = new DiagramCollection();
        return this._contextDiagrams[key];
    },

    _directories: function(context) {
        let key = context.projectId + ':' + context.dt;
        let directories = this._contextDirectories[key];
        if(directories) {
            return directories;
        }
        this._contextDirectories[key] = new Backbone.Collection();
        return this._contextDirectories[key];
    },

    getDiagrams: function(params) {
        return this._diagrams(params.context);
    },

    getDiagramDirectories: function(params) {
        return this._directories(params.context);
    },

    getNodeMetas: function(params) {
        return this._diagrams(params.context).get(
            params.context.diagramId)._nodeMetas;
    },

    getLinkMetas: function(params) {
        return this._diagrams(params.context).get(
            params.context.diagramId)._linkMetas;
    },

    clearAll: function() {
        this._contextDiagrams = {};
        this._contextDirectories = {};
    },

    dispatch: function(action) {
        switch(action.type) {
            case Actions.CREATE_DIAGRAM:
                this._createDiagram(action);
                break;
            case Actions.UPDATE_DIAGRAM:
                this._updateDiagram(action);
                break;
            case Actions.DELETE_DIAGRAM:
                this._deleteDiagram(action);
                break;
            case Actions.CREATE_NODE_META:
                this._createNodeMeta(action);
                break;
            case Actions.UPDATE_NODE_META_SYNC_STATE:
                this._updateNodeMetaSyncState(action);
                break;
            case Actions.UPDATE_NODE_META_EDIT_STATE:
                this._updateNodeMetaEditState(action);
                break;
            case Actions.UPDATE_NODE_META:
                this._updateNodeMeta(action);
                break;
            case Actions.DELETE_NODE_META:
                this._deleteNodeMeta(action);
                break;
            case Actions.MERGE_NODE_META:
                this._mergeNodeMeta(action);
                break;
            case Actions.CREATE_LINK_META:
                this._createLinkMeta(action);
                break;
            case Actions.UPDATE_LINK_META_SYNC_STATE:
                this._updateLinkMetaSyncState(action);
                break;
            case Actions.UPDATE_LINK_META_EDIT_STATE:
                this._updateLinkMetaEditState(action);
                break;
            case Actions.UPDATE_LINK_META:
                this._updateLinkMeta(action);
                break;
            case Actions.DELETE_LINK_META:
                this._deleteLinkMeta(action);
                break;
            case Actions.MERGE_LINK_META:
                this._mergeLinkMeta(action);
                break;

            // Directory
            case Actions.CREATE_DIAGRAM_DIRECTORY:
                this._createDirectory(action);
                break;
            case Actions.UPDATE_DIAGRAM_DIRECTORY:
                this._updateDirectory(action);
                break;
            case Actions.DELETE_DIAGRAM_DIRECTORY:
                this._deleteDirectory(action);
                break;
        }
    },

    _createDiagram: function(action) {
        let _diagrams = this._diagrams(action.context);
        if(!action.diagram) {
            return;
        }

        let diagrams = [];
        if(_.isArray(action.diagram)){
            diagrams = _.map(action.diagram, function(j) {
                return new DiagramModel(j);
            });
        } else {
            diagrams = [new DiagramModel(action.diagram)];
        }

        // fetch されたならパフォーマンスのために reset のみ飛ばす
        if(action.options && action.options.fetched) {
            _diagrams.add(diagrams, {merge: true, silent: true});
            _diagrams.trigger('reset');
            _diagrams.trigger('fetch');
        } else {
            _diagrams.add(diagrams, {merge: true});
        }
    },

    _updateDiagram: function(action) {
        let _diagrams = this._diagrams(action.context);
        if(!action.diagram) {
            return;
        }

        let diagrams = _.isArray(action.diagram) ?
            action.diagram : [action.diagram];
        _.each(diagrams, function(j) {
            let diagram = _diagrams.get(j.id);
            if(diagram) {
                diagram.set(j);
            }
        });
    },

    _deleteDiagram: function(action) {
        let _diagrams = this._diagrams(action.context);
        if(!action.diagram) {
            return;
        }

        let diagrams = _.isArray(action.diagram) ?
            action.diagram : [action.diagram];
        _diagrams.remove(diagrams);
    },

    _createNodeMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let nodeMetas = _.isArray(action.nodeMeta) ?
            action.nodeMeta : [action.nodeMeta];
        _.each(nodeMetas, function(j) {
            _diagram.createNodeMeta(j);
        });
    },

    _updateNodeMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let nodeMetas = _.isArray(action.nodeMeta) ?
            action.nodeMeta : [action.nodeMeta];
        _.each(nodeMetas, function(j) {
            let meta = _diagram.getNodeMeta(j.id);
            if(meta) {
                meta.set(j);
            }
        });
    },

    _deleteNodeMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let nodeMetas = _.isArray(action.nodeMeta) ?
            action.nodeMeta : [action.nodeMeta];
        _.each(nodeMetas, function(j) {
            _diagram.deleteNodeMeta(j.id);
        });
    },

    _mergeNodeMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let nodeMetas = _.isArray(action.nodeMeta) ?
            action.nodeMeta : [action.nodeMeta];

        _.each(nodeMetas, function(j) {
            if(j.creating && j.deleting) {
                return;
            }
            let meta = _diagram.getNodeMeta(j.id);
            let deleting = j.deleting;
            j.creating = false;
            j.deleting = false;
            if(!meta) {
                this._createNodeMeta({
                    context: action.context,
                    nodeMeta: j
                });
            } else if(deleting) {
                this._updateNodeMetaSyncState({
                    context: action.context,
                    state: SyncState.States.synced,
                    nodeMeta: {id: j.id}
                });
                this._deleteNodeMeta({
                    context: action.context,
                    nodeMeta: j
                });
            } else {
                this._updateNodeMeta({
                    context: action.context,
                    nodeMeta: j
                });
                this._updateNodeMetaSyncState({
                    context: action.context,
                    state: SyncState.States.synced,
                    nodeMeta: {id: j.id}
                });
            }
        }, this);
    },

    _updateNodeMetaSyncState: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let nodeMetas = _.isArray(action.nodeMeta) ?
            action.nodeMeta : [action.nodeMeta];
        _.each(nodeMetas, function(j) {
            _diagram.getNodeMeta(j.id)
                .syncState.setState(action.state);
        });
    },

    _updateNodeMetaEditState: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let nodeMetas = _.isArray(action.nodeMeta) ?
            action.nodeMeta : [action.nodeMeta];
        _.each(nodeMetas, function(j) {
            let meta = _diagram.getNodeMeta(j.id);
            if(meta) {
                switch(action.state) {
                    case 'start':
                        meta.startEdit();
                        break;
                    case 'end':
                        meta.endEdit();
                        break;
                    case 'cancel':
                        meta.cancelEdit();
                        break;
                }
            }
        });
    },

    _createLinkMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let linkMetas = _.isArray(action.linkMeta) ?
            action.linkMeta : [action.linkMeta];
        _.each(linkMetas, function(j) {
            _diagram.createLinkMeta(j);
        });
    },

    _updateLinkMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let linkMetas = _.isArray(action.linkMeta) ?
            action.linkMeta : [action.linkMeta];
        _.each(linkMetas, function(j) {
            let meta = _diagram.getLinkMeta(j.id);
            if(meta) {
                meta.set(j);
            }
        });
    },

    _deleteLinkMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let linkMetas = _.isArray(action.linkMeta) ?
            action.linkMeta : [action.linkMeta];
        _.each(linkMetas, function(j) {
            _diagram.deleteLinkMeta(j.id);
        });
    },

    _mergeLinkMeta: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let linkMetas = _.isArray(action.linkMeta) ?
            action.linkMeta : [action.linkMeta];

        _.each(linkMetas, function(j) {
            if(j.creating && j.deleting) {
                return;
            }
            let meta = _diagram.getLinkMeta(j.id);
            let deleting = j.deleting;
            j.creating = false;
            j.deleting = false;
            if(!meta) {
                this._createLinkMeta({
                    context: action.context,
                    linkMeta: j
                })
            } else if(deleting) {
                this._updateLinkMetaSyncState({
                    context: action.context,
                    state: SyncState.States.synced,
                    linkMeta: {id: j.id}
                });
                this._deleteLinkMeta({
                    context: action.context,
                    linkMeta: j
                });
            } else {
                this._updateLinkMeta({
                    context: action.context,
                    linkMeta: j
                });
                this._updateLinkMetaSyncState({
                    context: action.context,
                    state: SyncState.States.synced,
                    linkMeta: {id: j.id}
                });
            }
        }, this);
    },

    _updateLinkMetaSyncState: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let linkMetas = _.isArray(action.linkMeta) ?
            action.linkMeta : [action.linkMeta];
        _.each(linkMetas, function(j) {
            _diagram.getLinkMeta(j.id)
                .syncState.setState(action.state);
        });
    },

    _updateLinkMetaEditState: function(action) {
        let _diagram = this._diagrams(action.context).get(
            action.context.diagramId);
        let linkMetas = _.isArray(action.linkMeta) ?
            action.linkMeta : [action.linkMeta];
        _.each(linkMetas, function(j) {
            let meta = _diagram.getLinkMeta(j.id);
            if(meta) {
                switch(action.state) {
                    case 'start':
                        meta.startEdit();
                        break;
                    case 'end':
                        meta.endEdit();
                        break;
                    case 'cancel':
                        meta.cancelEdit();
                        break;
                }
            }
        });
    },

    _createDirectory: function(action) {
        let _directories = this._directories(action.context);
        if(!action.directory) {
            return;
        }

        let directories = [];
        if(_.isArray(action.directory)){
            directories = _.map(action.directory, function(j) {
                return new DirectoryModel(j);
            });
        } else {
            directories = [new DirectoryModel(action.directory)];
        }

        // fetch されたならパフォーマンスのために reset のみ飛ばす
        if(action.options && action.options.fetched) {
            _directories.add(directories, {merge: true, silent: true});
            _directories.trigger('reset');
            _directories.trigger('fetch');
        } else {
            _directories.add(directories, {merge: true});
        }
    },

    _updateDirectory: function(action) {
        let _directories = this._directories(action.context);
        if(!action.directory) {
            return;
        }

        let directories = _.isArray(action.directory) ?
            action.directory : [action.directory];
        _.each(directories, function(j) {
            let directory = _directories.get(j.id);
            if(directory) {
                directory.set(j);
            }
        });
    },

    _deleteDirectory: function(action) {
        let _directories = this._directories(action.context);
        if(!action.directory) {
            return;
        }

        let directories = _.isArray(action.directory) ?
            action.directory : [action.directory];
        _.each(directories, function(j) {
            let directory = _directories.get(j.id);
            if(directory) {
                _directories.remove(directory);
            }
        });
    }
});

module.exports = new DiagramStore();



// WEBPACK FOOTER //
// ./system/domain/repository/diagram.js